import { GetContextData } from "./types";

export function generateEmptyContext(): GetContextData {
  return {
    notifications: { history: 0, reward: 0 },
    serverTime: new Date(),
    lootAggregate: [],
  };
}
